
import Badge from 'vux/src/components/badge/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Search from 'vux/src/components/search/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


const week = ['周日','周一','周二','周三','周四','周五','周六'];

const orderSrc = ['','公众号','自助二维码'];

export default {
directives: {
TransferDom
},
components: {
Badge,
Flexbox,
FlexboxItem,
Sticky,
Tab,
TabItem,
Search,
Group,
Cell,
XButton,
Confirm,
XDialog
},

activated () {
console.log('activated...')



document.getElementById('vux_view_box_body').scrollTop = this.$store.state.orderListScrollTop
},
created() {
this.initPageData()
},
mounted:function(){
},

computed: {

},
watch: {
},
data() {
return {
dialogMsg: '',
showHideOnBlur:false,
itemId:0,
OrderStatusCount: {

toAuditNum: 0,

toRefundNum: 0,

toConfirmNum: 0,

toConsumeNum: 0
},
page: 1,
pageSize: 10,
height: window.innerHeight, // 当前页面的高度
index: 0,
index01: 0,
results: [],
orderList: [],
value: '张三/18888888888',
shopId: this.$route.params.shopId,
orders: null,
ordersIndex: null,
confirmOrderData:{

confirm: false, // 默认关闭
confirmMsg: null, // 提示框内内容
refused: '确认拒单',
agreed: '确认接单',
checkResult: null, // 审核结果
checkRemark: null, // 审核备注
orderNo: null,
userId: null,
},

consumeOrderData:{

confirm: false, // 默认关闭
confirmMsg: null, // 提示框内内容
refused: '取消核销',
agreed: '确认核销',
checkResult: null, // 审核结果
checkRemark: null, // 审核备注
orderNo: null,
userId: null,
voucherNo: null,
},

refundOrderData:{

confirm: false, // 默认关闭
confirmMsg: null, // 提示框内内容
refused: '拒绝退款',
agreed: '同意退款',
checkResult: null, // 审核结果
checkRemark: null, // 审核备注
orderNo: null,
userId: null,
},

}
},
methods: {

initPageData() {




this.orders = {'ALL':[],'SHOP_CONFIRM_LIST':[],'REFUND_LIST':[],'CONSUME_LIST':[]}

this.ordersIndex =  [['ALL', 0],['SHOP_CONFIRM_LIST', 0],['REFUND_LIST', 0],['CONSUME_LIST', 0]]

this.getOrderStatusJump()

this.initOrderStatusCount()
},
getOrderStatusJump() {
let type = 0
switch(this.$route.query.t) {
case 'all':

break;
case 'confirm':
type = 1;
break;
case 'refund':
type = 2;
break;
case 'consume':
type = 3;
break;
default:
}
this.index = type
this.onItemClick(type)
},
confirmOrderEvent(orderNo, type, userId){
this.confirmOrderData.orderNo = orderNo
this.confirmOrderData.userId = userId

if (type == 1) {
this.confirmOrderData.checkResult = 'PASS'
this.confirmOrderData.confirmMsg = this.confirmOrderData.agreed
}else{
this.confirmOrderData.checkResult = 'REJECT'
this.confirmOrderData.confirmMsg = this.confirmOrderData.refused
}

this.confirmOrderData.confirm = true
},
consumeOrderEvent(orderNo, type, userId, voucherNo){
this.consumeOrderData.orderNo = orderNo
this.consumeOrderData.userId = userId
this.consumeOrderData.voucherNo = voucherNo

if (type == 1) {
this.consumeOrderData.checkResult = 'PASS'
this.consumeOrderData.confirmMsg = this.consumeOrderData.agreed
}else{
this.consumeOrderData.checkResult = 'REJECT'
this.consumeOrderData.confirmMsg = this.consumeOrderData.refused
}

this.consumeOrderData.confirm = true
},
refundOrderEvent(orderNo, type, userId){
this.refundOrderData.orderNo = orderNo
this.refundOrderData.userId = userId

if (type == 1) {
this.refundOrderData.checkResult = 'PASS'
this.refundOrderData.confirmMsg = this.refundOrderData.agreed
}else{
this.refundOrderData.checkResult = 'REJECT'
this.refundOrderData.confirmMsg = this.refundOrderData.refused
}

this.refundOrderData.confirm = true
},
onCancel () {
console.log('on cancel')
},
onHide () {
console.log('on hide')
},

onShowConfirm(){
this.$refs.confirmConfirm.setInputValue(this.confirmOrderData.confirmMsg)
},

onConfirmConfirm(value){

let shopId = this.shopId
let checkResult = this.confirmOrderData.checkResult
let orderNo = this.confirmOrderData.orderNo
let userId = this.confirmOrderData.userId
let _this = this
_this.axios.post('/v1/shop/'+shopId+'/order/tuan/SHOP_CONFIRM_ORDER', {'shopId':shopId,'orderNo':orderNo,'checkUser':userId,'checkResult':checkResult,'checkRemark':value}, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {
_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initPageData()
} else {
_this.dialogMsg = response.data.msg
_this.showHideOnBlur = true
}
}).catch(function (response) {
console.log(response);
});
},

onShowConsume(){
this.$refs.confirmConsume.setInputValue(this.consumeOrderData.confirmMsg)
},

onConfirmConsume(value){

let shopId = this.shopId
let checkResult = this.consumeOrderData.checkResult
let orderNo = this.consumeOrderData.orderNo
let userId = this.consumeOrderData.userId
let voucherNo = this.consumeOrderData.voucherNo
let _this = this

_this.axios.post('/v1/shop/'+shopId+'/order/tuan/CONSUME_ORDER', {'shopId':shopId,'consumeMthod':1,'voucherNo':voucherNo,'orderNo':orderNo,'checkUser':userId}, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {
_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initPageData()
} else {
_this.dialogMsg = response.data.msg
_this.showHideOnBlur = true
}
}).catch(function (response) {
console.log(response);
});
},

onShowRefund(){
this.$refs.confirmRefund.setInputValue(this.refundOrderData.confirmMsg)
},

onConfirmRefund(value){

let shopId = this.shopId
let checkResult = this.refundOrderData.checkResult
let orderNo = this.refundOrderData.orderNo
let userId = this.refundOrderData.userId
let _this = this

_this.axios.post('/v1/shop/'+shopId+'/order/tuan/REFUND_ORDER_CHECK', {'shopId':shopId,'orderNo':orderNo,'checkUser':userId,'checkResult':checkResult,'checkRemark':value}, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {
_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initPageData()
} else {
_this.dialogMsg = response.data.msg
_this.showHideOnBlur = true
}
}).catch(function (response) {
console.log(response);
});
},
openOrderDetail(orderId, userId) {

this.$store.commit('updateOrderListScrollTopPosition',
{top:document.getElementById('vux_view_box_body').scrollTop})
console.log(this.$store.state);
console.log('订单ID:', orderId);
let shopId = this.shopId
this.$router.push({
path: '/shop/'+shopId+'/tuanOrder/'+ orderId+'/user/'+ userId
});
},
onItemClick(type) {
this.itemId = type

this.ordersIndex[type][1] = 1
this.queryOrderList(type)

},
setFocus() {
this.$refs.search.setFocus()
},
resultClick(item) {
window.alert('you click the result item: ' + JSON.stringify(item))
},
getResult(val) {
console.log('on-change', val)
this.results = val ? getResult(this.value) : []
},
onSubmit() {
this.$refs.search.setBlur()
this.$vux.toast.show({
type: 'text',
position: 'top',
text: 'on submit'
})
},
onFocus() {
console.log('on focus')
},
onCancel() {
console.log('on cancel')
},
initOrderStatusCount(){
let shopId = this.shopId
let _this = this;

_this.axios.post('/v1/shop/'+shopId+'/order/tuan/GET_ORDER_NOTAUDIT_COUNT', {'shopId':shopId}, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {

_this.OrderStatusCount.toRefundNum = response.data.data.refundCount;
_this.OrderStatusCount.toConfirmNum = response.data.data.shopConfirmCount;
_this.OrderStatusCount.toConsumeNum = response.data.data.consumeCount;
}
}).catch(function (response) {
console.log(response);
});
},
/**
* 订单列表查询
* @param type
*/
queryOrderList(type){
let typeStr = this.ordersIndex[type][0]
let page = this.ordersIndex[type][1]
let pageSize = this.pageSize
let shopId = this.shopId
let _this = this;


_this.axios.post('/v1/shop/'+shopId+'/order/tuan/GET_ORDER_LIST', {'shopId':shopId,'queryType':typeStr,'currentPage':page,'pageSize':pageSize}, {
headers: {}
}).then(function (response) {


if (response.data.data != undefined && response.data.data.rows.length > 0) {
if (page < 2) {
_this.orders[typeStr] = []
}
let rows = response.data.data.rows
for (let i = 0; i < rows.length; i++) {
let validDate = "";
let d1 = rows[i].goodsInfo.validStartDate;
let d2 = rows[i].goodsInfo.validEndDate;
let date1 = new Date(d1);
let date2 = new Date(d2);
if (date1-date2==0) {
validDate = d1 + "(" + week[date1.getDay()] + ")";
} else {
validDate = d1 + "(" + week[date1.getDay()] + ")  至  " + d2 + "(" + week[date2.getDay()] + ")";
}

_this.orders[typeStr].push({
orderNo: rows[i].orderNo,
goodsName: rows[i].goodsInfo.goodsName,
goodsNum: rows[i].goodsInfo.quantity,
validDate: validDate,
price: rows[i].totalPrice/rows[i].goodsInfo.quantity*0.01,
totalPrice: rows[i].totalPrice*0.01,
contact: rows[i].guestNames,
sourceName: orderSrc[rows[i].saleChannelType],
statusName: rows[i].showStatus,
status: rows[i].status,
userId: rows[i].userId,
voucherNo: rows[i].goodsInfo.voucherNo,
})
}
_this.ordersIndex[type][1] = _this.ordersIndex[type][1]+1
}
}).catch(function (response) {
console.log(response);
});
},
}
}






















function getResult(val) {
let rs = []
for (let i = 0; i < 20; i++) {
rs.push({
title: `${val} result: ${i + 1} `,
other: i
})
}
return rs
}



// WEBPACK FOOTER //
// ./src/components/tuan_order/List.vue